module.exports = __webpack_public_path__ + "static/04.1_co-design-workshop.c273f00f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/04.1_co-design-workshop.jpg
// module id = 478
// module chunks = 110568472390859